export const BUTTON = 'button';
export const VIDEO = 'video';
export const FILE = 'file';
export const IMAGE = 'image';
export const TEXT = 'text';
export const OPT_IN = 'optIn';
export const SURVEY = 'survey';
